import { FEATURE_FLAGS } from './featureFlagConstants';

const PUBLIC_AUTH_PATHS = new Set([
  '/login',
  '/',
  '/forgot-password',
  '/reset-password',
  '/create-account',
  '/support',
  '/email-change/verify',
  '/email-updated',
  '/email-verification-invalid',
]);

const ROUTE_FEATURE_RULES = [
  { pathPrefix: '/partner-portal', flags: [FEATURE_FLAGS.EnablePartnerPortal] },
  { pathPrefix: '/admin/users', flags: [FEATURE_FLAGS.EnableAdmin, FEATURE_FLAGS.EnableAccountManagement] },
  { pathPrefix: '/admin/tenants', flags: [FEATURE_FLAGS.EnableAdmin, FEATURE_FLAGS.EnableTenantManagement] },
  { pathPrefix: '/admin/alerts', flags: [FEATURE_FLAGS.EnableAdmin, FEATURE_FLAGS.EnableAlertManagement] },
  { pathPrefix: '/admin', flags: [FEATURE_FLAGS.EnableAdmin] },
  { pathPrefix: '/profile/leadership-console', flags: [FEATURE_FLAGS.EnableAnalytics] },
  { pathPrefix: '/profile/manager-console', flags: [FEATURE_FLAGS.EnableAnalytics] },
  { pathPrefix: '/profile/analytics', flags: [FEATURE_FLAGS.EnableAnalytics] },
  { pathPrefix: '/profile/se-activities-impact-analysis', flags: [FEATURE_FLAGS.EnableAnalytics] },
  { pathPrefix: '/narrative-catalogue', flags: [FEATURE_FLAGS.EnableDemoIngestions] },
  { pathPrefix: '/catalogue/playbook', flags: [FEATURE_FLAGS.EnableDemoIngestions] },
  { pathPrefix: '/catalogue', flags: [FEATURE_FLAGS.EnableDemoIngestions] },
  { pathPrefix: '/reset', flags: [FEATURE_FLAGS.EnableDemoIngestions] },
  { pathPrefix: '/booking', flags: [FEATURE_FLAGS.EnableBookings] },
  { pathPrefix: '/sales', flags: [FEATURE_FLAGS.EnableSalesDemo] },
  { pathPrefix: '/onboarding', flags: [FEATURE_FLAGS.EnableSalesDemo] },
  { pathPrefix: '/secure-view', flags: [FEATURE_FLAGS.EnableSalesDemo] },
  { pathPrefix: '/store/files', flags: [FEATURE_FLAGS.EnableContentStore] },
  { pathPrefix: '/store', flags: [FEATURE_FLAGS.EnableContentStore] },
  { pathPrefix: '/learning', flags: [FEATURE_FLAGS.EnableEnablement] },
  { pathPrefix: '/faq', flags: [FEATURE_FLAGS.EnableFAQ] },
  { pathPrefix: '/what-new', flags: [FEATURE_FLAGS.EnableWhatsNew] },
  { pathPrefix: '/support', flags: [FEATURE_FLAGS.EnableSupport] },
  { pathPrefix: '/demo-support', flags: [FEATURE_FLAGS.EnableSupport] },
  { pathPrefix: '/internal-support', flags: [FEATURE_FLAGS.EnableSupport] },
  { pathPrefix: '/innovation-suite', flags: [FEATURE_FLAGS.EnableAgent] },
  { pathPrefix: '/search', flags: [FEATURE_FLAGS.EnableSearch] },
  { pathPrefix: '/update-email', flags: [FEATURE_FLAGS.EnableEmailMigration] },
  { pathPrefix: '/email-verification-sent', flags: [FEATURE_FLAGS.EnableEmailMigration] },
  { pathPrefix: '/email-updated', flags: [FEATURE_FLAGS.EnableEmailMigration] },
  { pathPrefix: '/email-verification-invalid', flags: [FEATURE_FLAGS.EnableEmailMigration] },
  { pathPrefix: '/forgot-password', flags: [FEATURE_FLAGS.EnableForgetPassword] },
  { pathPrefix: '/reset-password', flags: [FEATURE_FLAGS.EnableForgetPassword] },
  { pathPrefix: '/create-account', flags: [FEATURE_FLAGS.EnableAccountRequest] },
].sort((left, right) => right.pathPrefix.length - left.pathPrefix.length);

const normalizePath = (pathname) => {
  if (!pathname) {
    return '/';
  }

  const withoutQuery = pathname.split('?')[0];
  if (withoutQuery.length > 1 && withoutQuery.endsWith('/')) {
    return withoutQuery.slice(0, -1);
  }

  return withoutQuery || '/';
};

export const isPublicAuthPath = (pathname) => PUBLIC_AUTH_PATHS.has(normalizePath(pathname));

export const getRequiredFlagsForPath = (pathname) => {
  const normalizedPath = normalizePath(pathname);

  const matchedRule = ROUTE_FEATURE_RULES.find(({ pathPrefix }) => (
    normalizedPath === pathPrefix || normalizedPath.startsWith(`${pathPrefix}/`)
  ));

  return matchedRule?.flags || [];
};
